import "./index.css"
import HomePage from "./pages/HomePage/HomePage.jsx";


function App() {
  return (
    <>
      <main>
        <HomePage />
      </main>
    </>
  );
}

export default App;
